// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"880":"ddd9c692","924":"ddd9c692"}[chunkId] + ".chunk.css";
};